<template>
  <div>
    <v-container ref="container" fluid id="container">
      <v-row class="fill-height px-5">
        <v-col align-self="start" cols="12">
          <v-row>
            <v-col>
              <router-link :to="{ name: 'home' }">
                <v-img src="@/assets/logo.svg" width="180px"></v-img>
              </router-link>
            </v-col>
          </v-row>
        </v-col>
        <v-col ml-5 align-self="center" cols="12">
          <h1
            class="display-3 font-weight-bold"
            v-html="title"
            v-if="$vuetify.breakpoint.mdAndUp"
          ></h1>
          <h1 class="font-weight-bold text-center" v-html="title" v-else></h1>
        </v-col>
        <v-col align-self="end" cols="12">
          <v-row justify="center">
            <v-col cols="auto">
              <a
                id="scrollDown"
                v-if="$vuetify.breakpoint.mdAndUp"
                @click="$vuetify.goTo('#next')"
              >
                <v-img src="@/assets/mouse.svg" width="30px"></v-img>
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div id="extranet">
        <a href="https://pagesti.monespaceclient.immo" target="_blank">
          <img src="@/assets/user.png" />
          <span class="white--text">ESPACE CLIENT</span>
        </a>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    bgImg: String,
  },
  mounted() {
    this.$refs.container.style.backgroundImage = `url(${require(`@/assets/${this.bgImg}`)})`;
  },
  methods: {
    scrollDown() {},
  },
};
</script>

<style lang="scss" scoped>
#container {
  height: 100vh;
  background-size: cover;
  background-position: center;
  position: relative;
  .logo {
    position: absolute;
    top: 1.5rem;
    left: 2.6rem;
  }
  h1 {
    text-transform: uppercase;
  }
  #scrollDown img {
    width: 30px;
  }
  #extranet {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #96c6f4;
    a {
      display: flex;
      align-items: center;
      padding: 0;
      text-decoration: none;
      font-weight: bold;
      color: #ffffff;
      img {
        flex: 0;
        width: 24%;
        border-right: 2px solid #ffffff;
      }
      span {
        flex: 1;
        text-align: center;
      }
    }
  }
}
</style>
